// extracted by mini-css-extract-plugin
module.exports = {"root":"Messages_root__1cWO6","header":"Messages_header__2AL7F"};